/*
 * @Author: 7
 * @Date: 2023-01-31 10:32:51
 * @LastEditTime: 2023-04-27 13:48:49
 * @FilePath: /sjtu-reference-canvas/src/page/EmailInfo.js
 */
/**
 * 问题反馈信息
 * 谢冉
 * 2020.8.25
 */
import '@instructure/canvas-theme';
import React, { useState } from 'react';
import { InPlaceEdit } from '@instructure/ui-editable';
import { NumberInput } from '@instructure/ui-number-input';

const EditInput = ({ orderNum, onSubmit }) => {
  const [mode, setMode] = useState('view');
  const [value, setValue] = useState(Number(orderNum || 0))

  const onChange = (orderNum) => {
    onSubmit(orderNum);
  }

  const handleChangeMode = (mode) => {
    setMode(mode)
  }

  const handleChange = (event, value) => {
    console.log(event.target.value, value);
    setValue(value ? Number(value) : 0)
  }

  // const renderView = () => <Text size="large">{value}</Text>
  const renderView = () => value

  const renderEdit = ({ onBlur, editorRef }) => (
    <NumberInput
      width='100px'
      display="inline-block"
      showArrows={false}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      inputRef={editorRef}
    />
  )

  const renderEditButton = (props) => {
    props.label = `Edit title "${value}"`
    return InPlaceEdit.renderDefaultEditButton({...props, isVisible: mode === 'view'})
  }

  return (
    <InPlaceEdit
      renderViewer={renderView}
      renderEditor={renderEdit}
      renderEditButton={renderEditButton}
      onChangeMode={handleChangeMode}
      mode={mode}
      value={value}
      onChange={onChange}
      showFocusRing={true}
    />
  )
}

export default EditInput;
